import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesJournalReport extends Layout {
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxGL: ExcludableTextbox;
    sourceSalesJournal: DataSource;
    switchSort: Switch;
    textboxDateRange: Textbox;
    textboxReportType: Textbox;
}
